export function isIPadOSDesktopBrowser(userAgent: string, maxTouchPoints: number) {
  return userAgent.includes('Macintosh') && maxTouchPoints > 1
}